export default __webpack_public_path__ + "static/media/bg-shorten-desktop.0d9742f4.svg";